import styled from "styled-components";

export const _Table = styled.table`
  border-collapse: collapse;
  caption-side: bottom;
  width: 100%;
  margin-top: 20px;
`;

export const _TableData = styled.td`
  border: solid 1px #000;
  padding: 5px 2px;
  font-size: 10px;
  width: 20%;

  @media (min-width: 768px) {
    font-size: 16px;
    padding: 10px 5px;
  }
`;

export const _TableHeader = styled(_TableData)`
  text-align: center;
  vertical-align: baseline;
  font-weight: bold;
  }
`;

export const _Headline = styled(_TableData)`
  font-weight: bold;
`;

export const _SeasonName = styled.span`
  display: block;
`;

export const _TableRow = styled.tr`
  border-bottom: none !important; // Scensum css override
  background: ${({ type }) =>
    (type === "period" && "#EFF7EE") ||
    (type === "parti" && "#C5E0F0") ||
    (type === "roof" && "#E9D2CE") ||
    "none"};
`;
